/**
 *  The back-end domain object for POS is not a great design and there are a lot of ambiguity and confusion,
 *   to make it easier to build this component and abstract the domain object we have created this map to
 *   manipulate names and default values
 */
function domainNamesConstant() {
    return {
        MAP_FIELD_NAME: {
            // defaultValue here is from the server, e.g: pat is false but for all posType
            name: {
                betterName: 'merchantName',
                defaultValue: undefined,
                transient: true
            },
            id: {
                betterName: 'id',
                defaultValue: undefined
            },
            integration: {
                betterName: 'integration',
                defaultValue: 'fulfillment'
            },
            posType: {
                betterName: 'posType',
                defaultValue: undefined,
                merchantPosPropKey: true
            },
            posPartnerId: {
                betterName: 'posPartnerId',
                defaultValue: undefined
            },
            claimByItemEnabled: {
                betterName: 'claimByItemEnabled',
                defaultValue: true,
                merchantPosPropKey: true
            },
            enableStoreId: {
                betterName: 'enableStoreId',
                defaultValue: false,
                merchantPosPropKey: true
            },
            securityCode: {
                betterName: 'securityCode',
                defaultValue: undefined
            },
            comtrexEndpointUrl: {
                betterName: 'comtrexEndpointUrl',
                defaultValue: undefined
            },
            payAtTable: {
                betterName: 'payAtTable',
                defaultValue: false
            },
            payAtTableOverride: {
                betterName: 'payAtTable',
                defaultValue: false,
                isOutlet: true
            },
            orderAtTableEnabled: {
                betterName: 'orderAtTable',
                defaultValue: false,
                merchantPosPropKey: true
            },
            payAtTablePosMenuRef: {
                betterName: 'payAtTablePosMenuRef',
                defaultValue: undefined,
                merchantPosPropKey: true,
                outletPosProsKey: true
            },
            orderAtTablePosMenuRef: {
                betterName: 'orderAtTablePosMenuRef',
                defaultValue: undefined
            },
            minPayAtTableNumber: {
                betterName: 'minPayAtTableNumber',
                defaultValue: undefined
            },
            maxPayAtTableNumber: {
                betterName: 'maxPayAtTableNumber',
                defaultValue: undefined
            },
            usePaymentType: {
                betterName: 'usePaymentType',
                defaultValue: false,
                merchantPosPropKey: true
            },
            orderAtTableMenuSync: {
                betterName: 'orderAtTableMenuSync',
                defaultValue: false,
                outletPosProsKey: true,
                merchantPosPropKey: true
            },
            omnivoreEmployeeId: {
                betterName: 'omnivoreEmployeeId',
                defaultValue: "",
                merchantPosPropKey: true,
                outletPosProsKey: true
            },
            omnivorePatOrderTypeId: {
                betterName: 'omnivorePatOrderTypeId',
                defaultValue: "",
                merchantPosPropKey: true,
                outletPosProsKey: true
            },
            omnivoreRevenueCenterId: {
                betterName: 'omnivoreRevenueCenterId',
                defaultValue: "",
                merchantPosPropKey: true,
                outletPosProsKey: true
            },
            omnivoreTenderTypeId: {
                betterName: 'omnivoreTenderTypeId',
                defaultValue: "",
                merchantPosPropKey: true,
                outletPosProsKey: true
            },
            webhookId: {
                betterName: 'webhookId',
                defaultValue: "",
                merchantPosPropKey: true,
                outletPosProsKey: true
            },
            barTabEnabled: {
                betterName: 'barTab',
                defaultValue: false
            },
            barTabOverride: {
                betterName: 'barTab',
                defaultValue: false,
                isOutlet: true
            },
            barTabPosMenuRef: {
                betterName: 'barTabPosMenuRef',
                defaultValue: undefined
            },
            minBarTabTableNumber: {
                betterName: 'minBarTabTableNumber',
                defaultValue: undefined
            },
            maxBarTabTableNumber: {
                betterName: 'maxBarTabTableNumber',
                defaultValue: undefined
            },
            autoBillingOverride: {
                betterName: 'autoBilling',
                defaultValue: true
            },
            upfrontCardValidationOverride: {
                betterName: 'upfrontCardValidation',
                defaultValue: true
            },
            billAutoUpdate: {
                betterName: 'isBillAutoUpdate',
                defaultValue: false,
                merchantPosPropKey: true,
                outletPosProsKey: true
            },
            userProvidesTableId: {
                betterName: 'isTableCodeProvided',
                defaultValue: false,
                merchantPosPropKey: true,
                outletPosProsKey: true
            },
            posWalkoutThresholdMinutes: {
                betterName: 'posWalkoutThresholdMinutes',
                defaultValue: undefined
            },
            checkIDLength: {
                betterName: 'checkIDLength',
                defaultValue: undefined
            },
            enablePollingForApiChecks: {
                betterName: 'enablePollingForApiChecks',
                defaultValue: false
            },
            posProductCodeLookupFilePath: {
                betterName: 'posProductCodeLookupFilePath',
                defaultValue: undefined
            },
            orderAheadEnabled: {
                betterName: 'collection',
                defaultValue: false
            },
            orderAheadOverride: {
                betterName: 'collection',
                defaultValue: false,
                isOutlet: true
            },
            collectionEnabled: {
                betterName: 'collectionWithTimeSlots',
                defaultValue: false
            },
            takeawayMenuSync: {
                betterName: 'takeAwayMenuSync',
                defaultValue: true,
                merchantPosPropKey: true,
                outletPosProsKey: true
            },
            collectionPosMenuRef: {
                betterName: 'collectionPosMenuRef',
                defaultValue: undefined
            },
            collectionIntervals: {
                betterName: 'collectionIntervals',
                defaultValue: undefined
            },
            preparationTime: {
                betterName: 'preparationTime',
                defaultValue: undefined
            },
            fulfilmentHoursAhead: {
                betterName: 'fetchInHours',
                defaultValue: undefined
            },
            fulfilmentMinutesAhead: {
                betterName: 'fetchInMinutes',
                defaultValue: undefined
            },
            appKey: {
                betterName: 'appKey',
                defaultValue: undefined
            },
            appCode: {
                betterName: 'appCode',
                defaultValue: undefined
            },
            posUrl: {
                betterName: 'posUrl',
                defaultValue: undefined,
                outletPosProsKey: true
            },
            useMerchantSettings: {
                betterName: 'isUseMerchantSettings',
                defaultValue: false
            },
            autoBillingContactDetails: {
                betterName: 'autoBillingContactDetails',
                defaultValue: undefined
            }
        }
    }
}
angular.module('qkr.integration.settings').constant('domainNamesConstant', domainNamesConstant());


// WEBPACK FOOTER //
// ./src/integration-settings/constants/domain.names.constant.js